import { render, staticRenderFns } from "./AdminStudentsFields.vue?vue&type=template&id=4c2587d5"
import script from "./AdminStudentsFields.vue?vue&type=script&lang=js"
export * from "./AdminStudentsFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports